module.exports = __webpack_public_path__ + "img/gun.8a72156b.png";